// removed by extract-text-webpack-plugin
module.exports = {"login":"Login__login___12NU2","loginForm":"Login__loginForm___3Zu4u","logo":"Login__logo___2-9VR","error":"Login__error___Xog-I","shake":"Login__shake___2fmmc"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Login/components/Login.scss
// module id = 1213
// module chunks = 1